import styled from '@emotion/styled';

export const FloatingHelpButtonContainer = styled.div`
  position: fixed;
  bottom: 30px;
  left: 30px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.palette?.brand.primary.base};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  z-index: 9999999;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const HelpButtonText = styled.span`
  font-weight: 500;
  font-size: 14px;
  color: white;
`;
